import { FC } from "react";
import { AspectRatio, Box, Container } from "@radix-ui/themes";
import useViewportWidth from "@/hooks/useViewportWidth";

interface SingleZoneProductsProps {
  productImage: string;
  title: string;
}

export const SingleZoneProducts: FC<SingleZoneProductsProps> = ({
  productImage,
  title,
}): JSX.Element => {
  const isMobile = useViewportWidth(768);
  const isTablet = useViewportWidth(1280);
  return (
    <Box className="align-full" style={{ backgroundColor: "var(--accent-10)" }}>
      <Container py="9" px={{ initial: "4", md: "2", xl: "0" }}>
        <AspectRatio ratio={isMobile ? 4 / 3 : isTablet ? 4 / 2 : 3 / 1}>
          <img
            src={productImage}
            alt={title}
            style={{
              objectFit: "cover",
              width: "100%",
              height: "100%",
              borderRadius: "0.5rem",
            }}
          />
        </AspectRatio>
      </Container>
    </Box>
  );
};
